module.exports = __webpack_public_path__ + "SuryaVamsi5-bffc87e1.png";